import OffrePrestation from '../components/OffrePrestation';

function NotreOffre() {
  const listeOffres = [
    { titre: 'Ingénierie', image: './images/prestation_ingenierie.avif', description: 'i2c mobilise ses compétences en sciences de l’ingénieur pour concevoir, prototyper et optimiser vos projets techniques. Nous accompagnons vos idées depuis la phase de conception jusqu’à la réalisation, en assurant rigueur et innovation à chaque étape.', lien: './ingenierie' },
    { titre: 'Conseil', image: './images/prestation_conseil.avif', description: 'i2c vous apporte un regard expert et stratégique sur vos projets. Nos équipes analysent vos besoins, identifient les opportunités et proposent des solutions concrètes et personnalisées pour maximiser la performance et l’impact de vos initiatives.', lien: './conseil' },
    { titre: 'Cognitique', image: './images/prestation_cognitique.avif', description: 'i2c exploite les principes de la cognitique pour améliorer l’interaction entre l’homme et la technologie dans vos projets. Nous développons des solutions centrées utilisateur, alliant ergonomie et design, pour des résultats à la fois efficaces et intuitifs.', lien: './cognitique' },
  ];

  const offrePrestation = (
    <div className="flex flex-col md:flex-row flex-wrap justify-center items-center gap-8">
      {listeOffres.map((offre, index) => (
        <OffrePrestation key={index} image={offre.image} titre={offre.titre} description={offre.description} lien={offre.lien}/>
      ))}
    </div>
  );

  return (
    <div>
      <div id="notre_offre" className="flex flex-col justify-center gap-[21px] px-4">
        <h3 className="px-6 text-gris-sombre dark:text-blanc-sombre text-[40px] font-extrabold text-center">Notre <span className="text-bleu-je">offre</span> de prestation</h3>
        {offrePrestation}
      </div>
    </div>
  );
}

export default NotreOffre;